<template>
  <AssessmentForm @submit.prevent="onSubmit" :showSkip="!selected.length">
    <template slot="header">{{ header }}</template>
    <template slot="description">
      <p>
        Each question is completely optional and you can skip any step.
      </p>
    </template>
    <div class="field-container">
      <CheckboxGrid
        :options="careNeeds"
        :selected="selected"
        @change="onCheck"
      />
    </div>
  </AssessmentForm>
</template>

<script>
import AssessmentForm from '@/components/assessment-form';
import CheckboxGrid from '@/components/checkbox-grid';
import { CareNeeds } from '@/store/types';
import { StoreGetters, saveCareNeeds } from '@/store';
import { mapGetters } from 'vuex';

export default {
  components: { AssessmentForm, CheckboxGrid },
  data() {
    return {
      isLoading: false,
      selected: [...this.$store.state.careNeeds],
    };
  },
  computed: {
    ...mapGetters({ name: StoreGetters.GET_USER_NAME }),
    header() {
      let result = this.name ? `${this.name}, did` : 'Did';
      result += ' your Doctor advise for special care?';
      return result;
    },
    careNeeds() {
      return Object.entries(CareNeeds).map(([k, v]) => ({
        value: k,
        label: v,
      }));
    },
  },
  methods: {
    onCheck({ isChecked, value }) {
      if (!isChecked) {
        this.selected = this.selected.filter(item => item !== value);
      }
      if (isChecked && !this.selected.includes(value)) {
        this.selected = [...this.selected, value];
      }
    },
    async onSubmit() {
      if (this.isLoading) return;
      this.isLoading = true;
      await saveCareNeeds(this.selected);
      this.isLoading = false;
      this.$emit('submit');
    },
  },
};
</script>

<style lang="scss" scoped></style>
